var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from "vue";
import AppConfig from "~/config/app.config";
import Component from "vue-class-component";
import VerifyCode from "~/components/common/verify-code.vue";
import { Action, State, namespace } from "vuex-class";
import { Dependencies } from "~/core/decorator";
import { StorageService } from "~/utils/storage.service";
import { LoginService } from "~/services/management-service/login.service";
var workspaceModule = namespace("workspace");
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.appConfig = AppConfig;
        _this.remember = false;
        _this.submitLoading = false;
        _this.rules = {
            userName: { required: true, message: "用户名不能为空", trigger: "blur" },
            password: { required: true, message: "密码不能为空", trigger: "blur" }
        };
        _this.loginModel = {
            userName: "",
            password: ""
        };
        _this.loginForm = {};
        _this.verifyForm = {};
        _this.rember = {};
        return _this;
    }
    Login.prototype.login = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.loginService.login(_this.loginModel).subscribe(function (data) {
                            resolve(data);
                        }, function (error) {
                            reject();
                        });
                    })];
            });
        });
    };
    /**
     * 提交登录表单
     */
    Login.prototype.submitForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.submitLoading = true;
                this.loginForm = this.$refs["login-form"];
                this.loginForm.validate(function (success) {
                    if (!success) {
                        return;
                    }
                    _this.verifyForm = _this.$refs["verify-code"];
                    if (_this.remember) {
                        StorageService.setItem("remember", _this.loginModel);
                    }
                    else {
                        StorageService.removeItem("remember");
                    }
                    // 用户登录
                    _this.loginService.login(_this.loginModel).subscribe(function (user) {
                        // 更新登录数据
                        _this.updateUserLoginData(user);
                        // 根据角色列表获取资源
                        _this.loginService.getAllResourcesByRoleId(user).subscribe(function (resources) {
                            // 更新资源信息
                            _this.updateResourcesData(resources);
                            _this.submitLoading = false;
                            // 跳转到菜单的第一个子菜单
                            var tree = _this.getRoleTreeData();
                            var url = tree.length && tree[0].children.length ? tree[0].children[0].url : '';
                            _this.$router.push(url);
                            _this.updateMessageBoxVisible(false);
                            _this.updatedIsMessageShow(false);
                        });
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    Login.prototype.getRoleTreeData = function () {
        var option = {
            keyName: 'id',
            parentKeyName: 'parent',
            sortKey: 'resoSort'
        };
        return this.$common.generateTreeData(this.menuResource, option);
    };
    Login.prototype.mounted = function () {
        this.rember = StorageService.getItem("remember");
        this.remember = !!this.rember;
        if (this.rember) {
            this.loginModel = this.rember;
        }
    };
    __decorate([
        Dependencies(LoginService)
    ], Login.prototype, "loginService", void 0);
    __decorate([
        workspaceModule.Mutation
    ], Login.prototype, "updateMessageBoxVisible", void 0);
    __decorate([
        workspaceModule.Mutation
    ], Login.prototype, "updatedIsMessageShow", void 0);
    __decorate([
        Action("updateUserLoginData")
    ], Login.prototype, "updateUserLoginData", void 0);
    __decorate([
        Action("updateResourcesData")
    ], Login.prototype, "updateResourcesData", void 0);
    __decorate([
        State
    ], Login.prototype, "menuResource", void 0);
    Login = __decorate([
        Component({
            components: {
                VerifyCode: VerifyCode
            }
        })
    ], Login);
    return Login;
}(Vue));
export default Login;
